import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ModifyScheduleComponent } from './modify-schedule.component';

@NgModule({
   declarations: [ModifyScheduleComponent],
   imports: [
      CommonModule,
      MatButtonModule,
      MatDialogModule,
      MatFormFieldModule,
      MatIconModule,
      MatInputModule,
      MatInputModule,
      ReactiveFormsModule,
   ],
})
export class ModifyScheduleModule {}
